import { useState, useCallback } from "react";
import { useIdleTimer } from "react-idle-timer";

const FORTY_FIVE_MINUTES_MS = 45 * 60 * 1000;
const ONE_MINUTE_MS = 60 * 1000;

interface UseAutoLogoutProps {
  onLogout: () => void;
  onInactivityLogout?: () => void;
}

export function useAutoLogout({
  onLogout,
  onInactivityLogout,
}: UseAutoLogoutProps) {
  const [showWarning, setShowWarning] = useState(false);

  const handleIdle = useCallback(() => {
    setShowWarning(false);
    onInactivityLogout?.();
    onLogout();
  }, [onLogout, onInactivityLogout]);

  const handlePrompt = useCallback(() => {
    setShowWarning(true);
  }, []);

  const handleActivity = useCallback(() => {
    setShowWarning(false);
  }, []);

  const { activate } = useIdleTimer({
    timeout: FORTY_FIVE_MINUTES_MS,
    promptBeforeIdle: ONE_MINUTE_MS,
    onIdle: handleIdle,
    onPrompt: handlePrompt,
    onActive: handleActivity,
    throttle: 500,
    eventsThrottle: 200,
    crossTab: true,
    syncTimers: 500,
  });

  const handleStayLoggedIn = useCallback(() => {
    setShowWarning(false);
    activate();
  }, [activate]);

  return {
    showWarning,
    handleStayLoggedIn,
    handleActivity,
  };
}
